import React, { Component } from 'react';
import styles from './notFound.scss';

class NotFound extends Component {
  render() {
    return (
      <div className={styles.container}>
        404: Seite nicht gefunden.
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/layout/notFound/notFound.jsx